import React, { useState, useEffect } from "react";
import { Spinner } from "mondrian-react";

export default function Loading(props) {
  const isLoading = props.isLoading;
  const [forceClose, setForceClose] = useState(false);
  useEffect(function () {
    let timeout;
    timeout = window.setTimeout(function () {
      setForceClose(true);
    }, 20000);
    return () => clearInterval(timeout);
  });
  if (!isLoading) return null;
  // function handleClick() {
  //   if (window.grecaptcha && !window.grecaptcha.getResponse()) {
  //     setForceClose(true);
  //   }
  // }
  // if (forceClose) {
  //   return null;
  // }
  return (
    <div
      // onClick={handleClick}
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        opacity: "0.9",
        zIndex: 5,
      }}
    >
      <Spinner
          isLoading={isLoading}
      />
    </div>
  );
}
